import React from 'react';
import Image from 'next/image';
import { Block, BLOCKS, Inline, INLINES } from '@contentful/rich-text-types';

import { ISplitFormFields } from '@/types/contentful';

import { Flexbox } from '../../Flexbox';
import { Text } from '../../Text';
import RichText from '../../RichText';
import { EmbeddedInlineEntryNode } from '../../RichText/Nodes';

import { InlineAnchor } from '../../RichText/styles';
import { ImageWrapper, SpinningBadge, WhiteCheckmark } from './styles';

import tealBadge from '@/images/teal-badge.svg';
import checkmark from '@/images/check.svg';

type SuccessProps = Pick<ISplitFormFields, 'successHeading' | 'successMessage'>;

export function FormSuccess({ successHeading, successMessage }: SuccessProps) {
  return (
    <Flexbox
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      padding={{ 0: ['2xl', 'ml'], desktop: '2xl' }}
    >
      <ImageWrapper marginBottom="l">
        <SpinningBadge>
          <Image src={tealBadge} alt="Rotating green badge" />
        </SpinningBadge>
        <WhiteCheckmark>
          <Image
            src={checkmark}
            alt="White checkmark icon"
            height={70}
            width={70}
          />
        </WhiteCheckmark>
      </ImageWrapper>

      <Text
        as="h4"
        textAlign="center"
        fontWeight="500"
        fontSize={{ desktop: 'l' }}
        lineHeight={{ desktop: 'm' }}
        marginBottom="s"
      >
        {successHeading}
      </Text>

      <RichText
        data={successMessage}
        overrideOptions={{
          [BLOCKS.PARAGRAPH]: (_node: Block | Inline, children) => (
            <Text
              as="p"
              textAlign="center"
              fontWeight="400"
              fontSize={{ desktop: 'm' }}
              lineHeight={{ desktop: 'm' }}
              colour="defaultText"
            >
              {children}
            </Text>
          ),
          [INLINES.HYPERLINK]: (node, children) => (
            <InlineAnchor href={node.data.uri} colour="defaultText">
              {children}
            </InlineAnchor>
          ),
          [INLINES.EMBEDDED_ENTRY]: (node, children) => (
            <EmbeddedInlineEntryNode
              node={node}
              colour="defaultText"
              fontWeight="p"
            >
              {children}
            </EmbeddedInlineEntryNode>
          )
        }}
      />
    </Flexbox>
  );
}
